module.exports = __webpack_public_path__ + "img/home-07-cosmo-02-timeline-02.289444c4.jpg";